module.exports = __webpack_public_path__ + "img/ico-stop-record.9cb41c9b.svg";